var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 3.6,
    width: 7.8,
    height: 9.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6,
    y: 12.6,
    width: 8.8,
    height: 9.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.6,
    y: 16.6,
    width: 7.8,
    height: 5.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6,
    y: 3.6,
    width: 8.8,
    height: 5.8,
    rx: 1.4,
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenu);
export default __webpack_public_path__ + "static/media/dashboard-menu.0247dac7b6814755276eec1fd8ab2b7a.svg";
export { ForwardRef as ReactComponent };